import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import AdPlacement from './AdPlacement';

interface AdWrapperProps {
  children: ReactNode;
}

/**
 * AdWrapper component that wraps the main content and adds ads at the top and bottom
 * This is used at the application level to avoid having to modify each individual page
 */
const AdWrapper: React.FC<AdWrapperProps> = ({ children }) => {
  const location = useLocation();
  const path = location.pathname;
  
  // Skip ads on certain pages
  const skipAds = [
    '/privacy-policy',
    '/terms-of-service',
    '/about-us',
    '/contact',
  ].includes(path);

  // Generate a unique ad ID based on the path
  // This ensures each page has its own unique ad IDs
  const getAdId = (prefix: number): number => {
    // Use a simple hash function to generate a number from the path
    const hash = path.split('').reduce((acc, char) => {
      return acc + char.charCodeAt(0);
    }, 0);
    
    return prefix + (hash % 100); // Keep the number within a reasonable range
  };

  if (skipAds) {
    return <>{children}</>;
  }

  return (
    <div className="ad-wrapper">
      {/* Top ad */}
      <div className="mb-6">
        <AdPlacement id={getAdId(1000)} />
      </div>
      
      {/* Main content */}
      {children}
      
      {/* Bottom ad */}
      <div className="mt-6 mb-6">
        <AdPlacement id={getAdId(2000)} />
      </div>
    </div>
  );
};

export default AdWrapper;